const initialState = {
  searchQuery: "",
  reset: 0
};

export default initialState;
